import { LitElement, html, css } from "lit";

import shared from "../../../../shared/styles.scss";
import custom from "./exhibit-list.scss";

import "@shs/ui-marcom/src/js/collection";
import "@shs/ui-marcom/src/js/collection-item";

class ExhibitList extends LitElement {
  static get properties() {
    return {
      basePath: { attribute: "base-path" },
      project: { type: Object },
      activeEditBox: { type: String, attribute: false },
      boothTemplateType: { type: Object, attribute: false },
      selectedPlatform: { type: Object, attribute: false },
    };
  }

  static get styles() {
    return [css(shared), css(custom)];
  }

  constructor() {
    super();
    this.activeEditBox = "";
    this.boothTemplateType = "";
  }

  firstUpdated() {
    this.project.on("updated", () => {
      this.requestUpdate();
    });
  }

  setActiveEditBox(activeEditBox, index) {
    if (index >= 0) {
      this.activeEditBox = `${activeEditBox}_${index}`;
      return;
    }

    this.activeEditBox = activeEditBox;
  }

  render() {
    return html`
      <div class="exhibit-list">
        <uimc-collection>
          ${this.project.boothTemplate.type === "platform"
            ? html`
                ${this.project.get("exhibits").map((exhibit, index) => {
                  if (exhibit.platformName === this.selectedPlatform) {
                    return html`
                      <uimc-collection-item>
                        <exhibit-list-item
                          base-path=${this.basePath}
                          .project=${this.project}
                          .exhibit=${exhibit}
                          index=${index}
                          activeEditBox=${this.activeEditBox}
                          .setActiveEditBox=${this.setActiveEditBox.bind(this)}
                        ></exhibit-list-item>
                      </uimc-collection-item>
                    `;
                  }
                  return null;
                })}
              `
            : html`
                ${this.project.get("exhibits").map((exhibit, index) => {
                  return html`
                    <uimc-collection-item>
                      <exhibit-list-item
                        base-path=${this.basePath}
                        .project=${this.project}
                        .exhibit=${exhibit}
                        index=${index}
                        activeEditBox=${this.activeEditBox}
                        .setActiveEditBox=${this.setActiveEditBox.bind(this)}
                      ></exhibit-list-item>
                    </uimc-collection-item>
                  `;
                })}
              `}
        </uimc-collection>
      </div>
    `;
  }
}

customElements.define("exhibit-list", ExhibitList);
